import { AuthenticateUser } from '../../../adapter';

export default async function AuthenticateUserUsecase(User, AuthenticateUserStore) {
    await AuthenticateUser(User, AuthenticateUserStore);
    return;
}
